export default "__VITE_ASSET__549afa2f__"